module.exports = __webpack_public_path__ + "static/media/absolute-error.540b70b2.svg";